(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["papiereu-newsletter-popup"]) return;
  try {
    
  if (!customElements.get('papiereu-newsletter-popup')) {
    customElements.define('papiereu-newsletter-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[role="dialog"]');
        this.closeButtons = this.querySelectorAll('[data-newsletter-close]');
        this.storageKey = this.dataset.storageKey;
        this.lastFocus = null;
        this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
        this.addEventListener('keydown', (event) => this.onKeydown(event));

        const form = this.querySelector('form');
        form?.addEventListener('submit', () => {
          const submit = form.querySelector('[data-newsletter-submit]');
          if (submit) {
            submit.disabled = true;
            submit.setAttribute('aria-busy', 'true');
          }
        });

        this.querySelector('[data-newsletter-copy]')?.addEventListener('click', (event) => {
          const code = this.querySelector('[data-newsletter-code]')?.textContent.trim();
          if (!code) return;
          navigator.clipboard?.writeText(code).then(() => {
            event.currentTarget.textContent = event.currentTarget.dataset.copiedText;
          });
        });

        if (this.querySelector('[data-newsletter-success]')) {
          this.open();
          this.querySelector('[data-newsletter-success]')?.focus();
          return;
        }
        if (this.wasSeen()) return;
        this.schedule();
      }

      schedule() {
        const behavior = this.dataset.behavior;
        if (behavior === 'scroll') {
          const onScroll = () => {
            const max = document.documentElement.scrollHeight - window.innerHeight;
            const progress = max > 0 ? (window.scrollY / max) * 100 : 100;
            if (progress >= Number(this.dataset.scroll || 35)) {
              window.removeEventListener('scroll', onScroll);
              this.open();
            }
          };
          window.addEventListener('scroll', onScroll, { passive: true });
          onScroll();
          return;
        }
        const delay = behavior === 'immediate' ? 0 : Number(this.dataset.delay || 6) * 1000;
        window.setTimeout(() => this.open(), delay);
      }

      wasSeen() {
        try {
          if (this.dataset.frequency === 'every_visit') return false;
          if (this.dataset.frequency === 'session') return sessionStorage.getItem(this.storageKey) === '1';
          const seen = Number(localStorage.getItem(this.storageKey) || 0);
          return seen > Date.now() - Number(this.dataset.days || 30) * 86400000;
        } catch (error) {
          return false;
        }
      }

      remember() {
        try {
          if (this.dataset.frequency === 'session') sessionStorage.setItem(this.storageKey, '1');
          if (this.dataset.frequency === 'days') localStorage.setItem(this.storageKey, String(Date.now()));
        } catch (error) {}
      }

      open() {
        if (!this.hidden) return;
        this.lastFocus = document.activeElement;
        this.hidden = false;
        document.body.classList.add('papiereu-newsletter-open');
        requestAnimationFrame(() => this.dialog?.focus());
      }

      close() {
        this.remember();
        this.hidden = true;
        document.body.classList.remove('papiereu-newsletter-open');
        this.lastFocus?.focus?.();
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [...this.querySelectorAll('button:not([disabled]), input:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
